let ArrowKeySet = new Set('ArrowUp','ArrowLeft','ArrowRight','ArrowDown');

export default function handleValueBarKeyDown({e,clicked,setClicked,
  curValue,
  setTemporaryCellValue,
  setInputCursorValueRef}){

  //this is a comment;



  if( e.key === 'Enter' || e.key === 'Tab' ){
    e.preventDefault();

    if( e.altKey ){


      let targetEl = e.target;
      let cursorStart = targetEl.selectionStart;
      let cursorEnd = targetEl.selectionEnd;


      let newValue = curValue.slice(0,cursorStart) + '\n' + curValue.slice(cursorEnd);

      setInputCursorValueRef.current = cursorStart + 1;
      e.preventDefault();

      setTemporaryCellValue(newValue);

    }else if( !clicked ){

      //clicked means we're focused with a carot and have arrow keys to edit
      if( e.shiftKey ){
        //navigateLeft();

        const event = new KeyboardEvent('keydown', {
          key: 'ArrowLeft',
          code: 'ArrowLeft',
          keyCode: 39,
          which: 39,
          location: 0, // 0 for standard key, 1 for left key, 2 for right key, 3 for numpad
          ctrlKey: false,
          altKey: false,
          shiftKey: false,
          metaKey: false,
          repeat: false,
        });
        window.dispatchEvent(event);
        //handleArrowKey('ArrowLeft',e);
      }else{
        //navigateRight();
        const event = new KeyboardEvent('keydown', {
          key: 'ArrowRight',
          code: 'ArrowRight',
          keyCode: 39,
          which: 39,
          location: 0, // 0 for standard key, 1 for left key, 2 for right key, 3 for numpad
          ctrlKey: false,
          altKey: false,
          shiftKey: false,
          metaKey: false,
          repeat: false,
        });
        window.dispatchEvent(event);
        //handleArrowKey('ArrowRight',e);
      }
      setClicked(false);
    }
  }else if( e.key === 'Escape' || ArrowKeySet.has(e.key) ){
    //hitting this
    setClicked(false);
  }


}

